import debounce from 'lodash/fp/debounce.js';
import { change, formValueSelector } from 'redux-form';
import { REDUX_FORM_CHANGE } from '@hbrisk/sp3-risk-model-support/actions/types.js';
import {
  CITY,
  COUNTRY,
  LAT,
  LNG,
  STATE,
  STREET,
  ZIP,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { geocode } from '#actions/models/geocode.js';
import googleGeocodeUrl from '#support/models/geocoding/googleGeocodeUrl.js';
import format from '#support/models/formatCoordinateValue.js';

const setCoordinateFieldValuesBase = (store, form) => {
  const { dispatch, getState } = store;
  const state = getState();
  const {
    [STREET]: street,
    [CITY]: city,
    [STATE]: st,
    [COUNTRY]: country,
  } = formValueSelector(form)(state, STREET, CITY, STATE, COUNTRY);
  if (street && city && st && country) {
    dispatch(geocode(googleGeocodeUrl(street, city, st, country))).then(({ payload }) => {
      if (payload) {
        const { [LAT]: lat, [LNG]: lng } = payload;
        dispatch(change(form, LAT, format(lat)));
        dispatch(change(form, LNG, format(lng)));
      }
    });
  }
};

const setCoordinateFieldValues = debounce(500, setCoordinateFieldValuesBase);

const geocodeOnAddressChange = ({ store, action, form }) => {
  const { type } = action;

  if (type === REDUX_FORM_CHANGE) {
    const {
      meta: { field, form: actionForm },
    } = action;
    if (actionForm === form && [STREET, CITY, STATE, ZIP, COUNTRY].includes(field)) {
      setCoordinateFieldValues(store, form);
    }
  }
};

export default geocodeOnAddressChange;
